import { render, staticRenderFns } from "./porposal-budget-evaluation.vue?vue&type=template&id=868ccf42&scoped=true&"
import script from "./porposal-budget-evaluation.vue?vue&type=script&lang=ts&"
export * from "./porposal-budget-evaluation.vue?vue&type=script&lang=ts&"
import style0 from "./porposal-budget-evaluation.vue?vue&type=style&index=0&id=868ccf42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "868ccf42",
  null
  
)

export default component.exports